import { createTheme } from "@mui/material/styles";
import { generalTheme } from "./generalTheme";

export const lightTheme = createTheme({
  ...generalTheme,
  palette: {
    mode: "light",
    primary: {
      main: "#005CBB",
      onPrimary: "#FFF",
      primaryMark: "#ABC7FF",
      primaryContainer: "#D7E2FF",
      onPrimaryContainer: "#001B3F",
      primary30: "#00458F",
      stateLayers: {
        onPrimaryContainer: {
          onPrimary12: "#001B3F1F",
        },
        primary: {
          primary8: "#005CBB14",
          primary12: "#005CBB1F",
        },
      },
    },
    secondary: {
      main: "#00639C",
      main16: "#00639C29",
      secondaryContainer: "#CEE5FF",
      stateLayers: {
        secondaryContainer: {
          secondary16: "rgba(206, 229, 255, 0.16)",
          onHoverSelected: "#BED5F0",
        },
        primaryContainer: {
          primary16: "rgba(0, 27, 63, 0.12)",
        },
      },
    },
    tertiary: {
      main: "#326B14",
      tertiary: "#326B14",
      onTertiary: "#FFFFFF",
      tertiaryMark: "#98D774",
      tertiaryContainer: "#B3F48D",
      onTertiaryContainer: "#082100",
      stateLayers: {
        tertiary: {
          tertiary12: "#326B141F",
        },
      },
    },
    natural: {
      naturalMark: "#C5C6C9",
    },
    warning: {
      main: "#EEBC1E",
      warningMark: "#FFDD74",
      warningContainer: "#FFEEB9",
      onWarningContainer: "#7D6004",
      stateLayers: {
        warning: {
          warning12: "#EEBC1E1F",
        },
      },
    },
    error: {
      main: "#B4271D",
      stateLayers: {
        onSurface: {
          onSurface8: "#B4271D14",
        },
        error: {
          error12: "#B4271D1F",
        },
      },
      errorContainer: "#FFDAD5",
      errorMark: "#FFB4A9",
      onErrorContainer: "#410000",
      onError: "#FFFFFF",
    },
    surface: {
      main: "#EFF5FC",
      container: "#E0EBF8",
      containerHigh: "#D9E6F6",
      surface: "#FCFDFF",
      surface28: "#E8F0FA",
      surface514: "#D9E6F6",
      surfaceVariant: "#E0E2EC",
      onSurface: "#191C1E",
      onSurfaceVariant: "#44474E",
      onSurfaceMark: "#44474E1F",
      inverseSurface: "#2E3133",
      inverseOnSurface: "#F0F0F3",
      stateLayers: {
        onSurface: {
          onSurface8: "#091C1E14",
        },
        onSurfaceVariant: {
          onSurfaceVariant8: "#44474E14",
        },
      },
    },
    outline: {
      outline: "#74777F",
      outlineVariant: "#F1F3F8",
    },
    divider: "#F1F3F8",
    background: {
      color: "#F0F0F3",
      stateLayers: {
        onBackground: {
          onBackground8: "#191C1E14",
        },
        tabHover: "#E4E4E4",
        selectedTabHover: "#E2E9F1",
        datePicker: "#EEF5FD",
      },
    },
  },
});
